export default __webpack_public_path__ + "static/media/section9-background.17a3e184.jpg";